module.exports = __webpack_public_path__ + "static/media/cert_-1.fafd057e.jpg";